import { Component, OnInit } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Errors} from "../../core/models";
import { UserService } from "../../core/services/user.service";
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  title: String = '';
  errors: Errors = {errors: {}};
  isSubmitting = false;
  apiisSubmitting = false;
  authForm: FormGroup;
  loginForm: FormGroup;
  username = '';
  isLoggedin: boolean = false;

  constructor(
      public translate: TranslateService,
      private router: Router,
      private route: ActivatedRoute,
      private fb: FormBuilder,
      private userService: UserService,
  ) {

  }

  ngOnInit(): void { 
    this.initForm(); 
    this.isLoggedIn();
    
  }

  get f() { return this.loginForm.controls; }

  initForm(): void {
    this.loginForm = this.fb.group({
      grant_type:"password",
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  isLoggedIn() {

    if (localStorage.getItem('jwtToken')  == null) { 
      this.isLoggedin = false;
      return this.isLoggedin;
    } else {
      this.router.navigateByUrl('merchant/order');  
    }

  }

  isValidInput(fieldName): boolean {
 
    return this.loginForm.controls[fieldName].invalid &&
        (this.loginForm.controls[fieldName].dirty || this.loginForm.controls[fieldName].touched);

         
  }

  switchLang(lang: string) {
    this.translate.use(lang);
  }


  onSubmit() {
    this.apiisSubmitting = false;
    this.isSubmitting = true;
    this.errors = {errors: {}};

    const formData = this.loginForm.value;
    //this.loginForm.value.username = ('0' + this.loginForm.value.username).slice(-10)
     
  
    // get store merchant ID and merchant user Id

      // stop here if form is invalid
      if (this.loginForm.invalid) { 
        return;
    }
 
    this.userService
        .attemptAuth(formData)
        .subscribe( 
            (data) => {
              this.router.navigateByUrl('merchant/order')  
            },
            (err) => {
              this.apiisSubmitting = true;
              this.errors = err.validationFailures[0].code ; 
            }
        );  
  }

 

}
   
  
